module.exports = ".confirm-text {\n  padding: 25px 45px 15px 45px;\n  text-align: center;\n  color: #9e9e9e; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/patient-billing-modal/patient-billing-modal.component.scss
// module id = ./src/app/shared/components/patient-billing-modal/patient-billing-modal.component.scss
// module chunks = main